import { createAction } from 'redux-actions';
var prefix = 'Please Login:';
export var CLICKED_LOGIN_BUTTON = "".concat(prefix, " Track button clicked");
export var CANCELLED_LOGIN = "".concat(prefix, " Track cancelled login");
var clickedLoginButton = createAction(CLICKED_LOGIN_BUTTON);
var cancelledLogin = createAction(CANCELLED_LOGIN);
export var actionCreators = {
  clickedLoginButton: clickedLoginButton,
  cancelledLogin: cancelledLogin
};
//# sourceMappingURL=actions.js.map